import React from 'react';
import { Stack, Text } from '@moda/om';
import { useParams } from 'react-router-dom';
import { useOrder, OrderItemStatusGroup } from '../../../hooks/useOrder';
import { RequestReturnEligibleItem } from './RequestReturnEligibleItem';
import './RequestReturnEligibleItems.scss';

export const RequestReturnEligibleItems: React.FC = () => {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { orderItems = [] } = useOrder(orderNumber);

  const eligibleItems = orderItems.filter(
    item =>
      item.attributes.isReturnable && item.attributes.statusGroup === OrderItemStatusGroup.Shipped
  );

  if (eligibleItems.length === 0)
    return <Text treatment="h5">There are no returnable products in this order.</Text>;

  return (
    <Stack space={4}>
      <Text treatment="h5">Choose Items to Return</Text>
      <Stack space={0}>
        {eligibleItems.map(item => (
          <div key={item.id} className="RequestReturnEligibleItems__item">
            <RequestReturnEligibleItem item={item} />
          </div>
        ))}
      </Stack>
    </Stack>
  );
};
